import React, { PureComponent } from 'react';
import HigSideNav from '@hig/side-nav';
import {routesProvider} from '../../config/app-config';
import ThemeContext from '@hig/theme-context';
import HIGDarkBlueTheme from '@hig/theme-data/build/esm/darkBlueMediumDensityTheme';
import Groups from './SideNavGroups';

const {basename} = routesProvider;

const CopyrightElements = () => {
  return (
    <div>
      <p>© 2020 Autodesk Inc.</p>
    </div>
  )
}

class SideNav extends PureComponent {
  render() {
    return (
      <ThemeContext.Provider value={HIGDarkBlueTheme}>
        <nav className="pda-sidenav">
          <HigSideNav
            headerLabel="Pricing Data Application"
            headerLink={basename+'/'}
            groups={<Groups />}
            copyright={<CopyrightElements />}
          >
          </HigSideNav>
        </nav>
      </ThemeContext.Provider>
    )
  }
}

export default SideNav;
